import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PhotoflipperModalLoader } from './photoflipper-vdp-modal-loader';

export class PhotoflipperVdpModalAsync extends Component {
  state = {
    isLoaded: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.isOpen && !state.isLoaded) {
      return { isLoaded: true };
    }
    return null;
  }

  render() {
    return this.state.isLoaded ? <PhotoflipperModalLoader {...this.props} /> : null;
  }
}

PhotoflipperVdpModalAsync.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};
